import React, { useContext } from "react";
import Header from "../Header/Header";
import { AuthContext } from "../../contexts/AuthContext";

function HomeInicio() {
  // const { isAuth } = useContext(AuthContext);

  return (
    <>
      <Header />
      <div className="imgContainer">
        <img
          src="logoInstitucion2.png"
          height="50%"
          width="50%"
          className="imgLogo"
          alt="Logo"
        />
      </div>
    </>
  );
}

export default HomeInicio;
